export enum ETextSize {
  XS = `xs`,
  SM = `sm`,
  MD = `md`,
  LG = `lg`,
  XL = `xl`,
}

export enum EToggleSize {
  XS = `xs`,
  MD = `md`,
}
